import React, {Component} from "react";
import { NavLink } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

import "../../node_modules/swagger-ui/dist/swagger-ui.css"
import SwaggerUI from 'swagger-ui';

import "./SwaggerUIPage.css";

import Sidebar from "../components/Sidebar";
import PopupButton from "../components/PopupButton";
import PopUp from "../components/PopUp";
import logo from  "../components/Myntra_logo.png";
import { RedocStandalone } from 'redoc';
import PrivacyPolicy from "../components/PrivacyPolicy";
import {amcClientId, amcBaseUrl} from  "../common.config";

import qs from "qs";

const getOpenApiJsonContentUrl = "/getOpenApiJsonContent/openApiJsonLink/";
const getPostmanCollectionContentUrl="/getPostmanCollectionContent/postmanCollectionLink/";

var clientId = amcClientId || "myntra-swagger-49472439-e658-41f2-93c7-1d2cc36befa5"; //Both are Prod
var currentUrl = window.location.toString();
var fullUrl = amcBaseUrl + '/login?cidx=' + encodeURIComponent(clientId) + '&pageRequested=' + encodeURIComponent(currentUrl);


class SwaggerUIPage extends Component {
    state = {
        serviceEndpointListing: [],
        organizationName: "Myntra",
        openApiJsonLink: "",
        postmanCollectionLink: "",
        clientId: 1,
        showModal: false,
        versionData: [],
        openApiJsonName: "",
        postmanCollectionName: "",
        createdBy: "",
        lastModifiedOn: "",
        showPrivacyModal: false
    };

    componentDidMount() {
        if(this.checkURLParams()){
            var at = qs.parse(window.location.search).access_token;
            var rt = qs.parse(window.location.search).refresh_token;
            //validate at, rt
            this.setCookie("erp.at", at, 1);
            this.setCookie("erp.rt", rt, 1);
            this.setCookie("amc.enabled", true);
        }
        let isTokenValid = this.checkAuthenticated() ? this.validateToken() : false;
        //console.log(isTokenValid);
        if(!isTokenValid) {
          this.deleteCookie("erp.at");
          this.deleteCookie("erp.rt");
            window.location.assign(fullUrl);
        }

        else{
        this.getServiceEndpointListing()
          .then(res => {
            this.setState({serviceEndpointListing: res});
            if (this.state.serviceEndpointListing != null && this.state.serviceEndpointListing.length > 0) {
                this.setState({
                    openApiJsonLink: getOpenApiJsonContentUrl + this.state.serviceEndpointListing[0].openapi_json,
                    postmanCollectionLink: getPostmanCollectionContentUrl+this.state.serviceEndpointListing[0].postman_collectionv2,
                    clientId: this.state.serviceEndpointListing[0].id,
                    openApiJsonName: this.state.serviceEndpointListing[0].openapi_json,
                    postmanCollectionName: this.state.serviceEndpointListing[0].postman_collectionv2,
                    createdBy: this.state.serviceEndpointListing[0].created_by,
                    lastModifiedOn: this.state.serviceEndpointListing[0].last_modified_on
                });
            }
          })
        .catch(err => {});
        }
    }

    
    DisableTryItOutPlugin = function() {
        return {
          statePlugins: {
            spec: {
              wrapSelectors: {
                allowTryItOutFor: () => () => false
              }
            }
          }
        }
    }

    getServiceEndpointListing = async () => {
        const response = await fetch('/getServiceEndpointListing');
        const body = await response.json();
        if (response.status !== 200) throw Error(body.message);
        return body;
    }

    updateStateForNewSelectedClient = async (newOpenApiLink,newPostmanv2Link,newClientId,newOpenApiName,newPostmanCollectionName,newCreatedBy,newLastModifiedOn) => {
        this.setState({
            openApiJsonLink: getOpenApiJsonContentUrl + newOpenApiLink,
            postmanCollectionLink: getPostmanCollectionContentUrl + newPostmanv2Link,
            clientId: newClientId,
            openApiJsonName: newOpenApiName,
            postmanCollectionName: newPostmanCollectionName,
            createdBy: newCreatedBy,
            lastModifiedOn: newLastModifiedOn
        });
    }

    updateModalStates = async (show,versions) => {
        this.setState({
            showModal: show,
            versionData: versions
        });
    }

    updateModalStatesPP = async(showVal) => {
        this.setState({
            showPrivacyModal: showVal,
        });
    }

    validateToken = async () => {
        const response = await fetch('/validateToken');
        if(response.status !== 200) return false;
        // console.log(response.status);
        const body = await response.json();
        // if(!body["isTokenValid"]) window.location.assign(fullUrl);
        return body["isTokenValid"];
    }

    getCookie = (name) => {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
  
    setCookie =(name,value,days) => {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
  
    deleteCookie = (name) => {
        this.setCookie(name, '', -1)
    }

    checkAuthenticated = () => {
        var at = this.getCookie("erp.at");
        var rt = this.getCookie("erp.rt");
        return (at !== null && rt !== null);
    }
  
    checkURLParams = () => {
        var at = qs.parse(window.location.search).access_token;
        var rt = qs.parse(window.location.search).refresh_token;
        return at !== undefined && rt !==undefined
    }

    render() {
        return (
            <div className="SwaggerUIPage">
                <div className="SwaggerUIPageHeader">
                <img src={logo} alt="Myntra Logo"/>
                 <div id="header-text">
                    <h1>Developer API</h1>
                </div>
                <div className="wrap">
                    <div id="button-position">

                        <Dropdown variant="outline-light" >
                            <Dropdown.Toggle variant="outline-light" id="dropdown-basic">
                                Upload Service
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="dropdown-menu-yml-upload">
                                <NavLink to="/uploadPostmanCollection" exact>
                                    <Dropdown.Item href="#/action-1">Add Postman Collections</Dropdown.Item>
                                </NavLink>
                                <NavLink to="/uploadYamlFile" exact>
                                    <Dropdown.Item href="#/action-2">Add YAML File</Dropdown.Item>
                                </NavLink>
                            </Dropdown.Menu>
                        </Dropdown>
                        { this.props.disabled ? null : <NavLink className="UploadBtn" to="/selfserve" exact>
                            <Button variant="outline-light"> Onboard Team/Service </Button>
                        </NavLink> }

                    </div>
                    </div>
                </div>
                
                <div className="SwaggerUIPageBody">
                    <Sidebar
                        organizationName={this.state.organizationName}
                        definitionList={this.state.serviceEndpointListing}
                        updateDefinitionLink={this.updateStateForNewSelectedClient}
                        getOrganizationData={this.getOrganizationData}
                        internal={true}
                        updateModalStatesPP={this.updateModalStatesPP}
                    />
                    <div style={{width:"85%"}}>
                        <div id="api-data" />
                            <div className="button-align">
                                <div className="version-button">
                                <PopupButton
                                        clientId={this.state.clientId}
                                        updateModalStates={this.updateModalStates}
                                        latestOpenApi={this.state.openApiJsonName}
                                        latestPostmanCollection={this.state.postmanCollectionName}
                                        uploadedBy={this.state.createdBy}
                                        uploadedOn={this.state.lastModifiedOn}
                                    />
                                </div>
                            </div>
                        <RedocStandalone specUrl= {this.state.openApiJsonLink}
                            options={{
                            hideDownloadButton: true,
                            disableSearch: true,
                            theme: { 
                            sidebar: { width: "0px" }, 
                            colors: { primary: { main: '#5047C8' }}, 
                            rightPanel: {backgroundColor: "#302A8D", textColor: "#E5E2F5"}
                            }
                            }}
                        />
                        </div> 
                </div>
                

                <PopUp
                    show={this.state.showModal}
                    data={this.state.versionData}
                    updateModalStates={this.updateModalStates}
                />

                {/* <PrivacyPolicy
                show={this.state.showPrivacyModal}
                updateModalStatesPP={this.updateModalStatesPP}
                /> */}

            </div>
        )
    }
}

export default SwaggerUIPage;